import { setNodes, TNodeEntry, unwrapNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { ELEMENT_ROOT } from '../../pluginKeys';
import { DreamEditor } from '../../types';

export const normalizeRoot = (editor: DreamEditor) => {
  const { normalizeNode } = editor;

  return (entry: TNodeEntry) => {
    const [node, path] = entry;

    if (Path.equals(path, [0]) && node.type !== ELEMENT_ROOT) {
      setNodes(
        editor,
        {
          type: ELEMENT_ROOT,
          vertical_align: 'align_start',
        },
        { at: path },
      );
      return;
    }

    if (node.type === ELEMENT_ROOT && !Path.equals(path, [0])) {
      unwrapNodes(editor, { at: path });
      return;
    }

    normalizeNode(entry);
  };
};
